import { render } from "./Hero.vue?vue&type=template&id=0ccb3284&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=0ccb3284&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0ccb3284"

export default script